<template>
  <svg viewBox="0 0 25.183 25.183" v-on="$listeners">
    <path
      d="M0,42.793H10.793V32H0Zm3.6-7.2H7.2v3.6H3.6ZM14.39,32V42.793H25.183V32Zm7.2,7.2h-3.6V35.6h3.6ZM0,57.183H10.793V46.39H0Zm3.6-7.2H7.2v3.6H3.6Zm19.786-3.6h1.8v7.2h-5.4v-1.8h-1.8v5.4h-3.6V46.39h5.4v1.8h3.6Zm0,8.994h1.8v1.8h-1.8Zm-3.6,0h1.8v1.8h-1.8Z "
      transform="translate(0 -32)"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'code',
}
</script>
